/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { PaginatedResponse } from '../../../../shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '../../../../core/http/api-query';
import { RolesFormService } from '../roles-form.service';
import { RolesService } from '../roles.service';
import { Logger } from '@app/core';
import { UserRole } from '@app/settings/users/roles/user-role.model';
import { environment } from '@env/environment';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('rolesListComponent');

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss'],
})
export class RolesListComponent extends KendoGridComponent implements OnInit {
  rolesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private roleService: RolesService,
    private rolesFormService: RolesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('RolesListComponent');
    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);

    this.roleService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.rolesResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('RolesListComponent', this.state);
  }

  add() {
    this.rolesFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param userRole UserRole object
   */
  edit(userRole: UserRole) {
    this.rolesFormService.open(userRole);
  }

  /**
   *
   * @param role Locale object
   */
  delete(role: UserRole) {
    this.roleService.destroy(role.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
